import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { DesignService, QuickUrlService, SessionService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-header',
  styleUrls: ['./header.component.less'],
  templateUrl: './header.component.html',
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  public role$ = this.sessionService.role$;
  public urls$ = this.quickUrlService.quickUrls$;

  public readonly trackByRef = trackByRef;

  public readonly isDevOrLocal = this.sessionService.isDevOrLocal();
  public readonly environment = environment;

  public designUrl = '/data/design/';

  public queryParams: { tab: string } | { tab: string; equipmentNumber: string } = {
    tab: 'general',
  };

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly sessionService: SessionService,
    public router: Router,
    private readonly quickUrlService: QuickUrlService,
    private readonly designService: DesignService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(this.quickUrlService.load().subscribe());

    this.subscriptions.add(
      this.designService.selectQuery().subscribe((query) => {
        this.designUrl = `/data/design/${query?.designId ?? ''}`;

        this.queryParams = {
          tab: 'general',
          ...(query?.equipmentNumber ? { equipmentNumber: query.equipmentNumber } : {}),
        };
      })
    );
  }

  public toggleCollapsed() {
    this.sessionService.toggleSideMenuIsCollapsed();
  }
}
